import { createIcon } from '@chakra-ui/icons';

const Eye = createIcon({
  path: (
    <g>
      <path
        d="M1 5.727S3.364 1 7.5 1 14 5.727 14 5.727s-2.364 4.727-6.5 4.727S1 5.727 1 5.727z"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M7.5 7.5a1.773 1.773 0 100-3.546 1.773 1.773 0 000 3.546z"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </g>
  ),
  viewBox: '0 0 15 12',
});

export default Eye;
